import { render, staticRenderFns } from "./TelWithConfirm.vue?vue&type=template&id=75271e3c&scoped=true&"
import script from "./TelWithConfirm.vue?vue&type=script&lang=js&"
export * from "./TelWithConfirm.vue?vue&type=script&lang=js&"
import style0 from "./TelWithConfirm.vue?vue&type=style&index=0&id=75271e3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75271e3c",
  null
  
)

export default component.exports